import { render, staticRenderFns } from "./maintenanceamount.vue?vue&type=template&id=67b136d0&scoped=true"
import script from "./maintenanceamount.vue?vue&type=script&lang=js"
export * from "./maintenanceamount.vue?vue&type=script&lang=js"
import style0 from "./maintenanceamount.vue?vue&type=style&index=0&id=67b136d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67b136d0",
  null
  
)

export default component.exports